module.exports = __webpack_public_path__ + "static/poliProduct-91ce581212661d05271e57f7669b4f21.jpg";